var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Complaints50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fecc7f",
    d: "M44 42L4 42 7 27 41 27 44 42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a75e40",
    d: "M36,36H12a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H36a2,2,0,0,1,2,2h0A2,2,0,0,1,36,36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#feba57",
    d: "M23,6l7.76,9.05A4.83,4.83,0,0,1,31,17l-3.68,8.19A3.88,3.88,0,0,1,25,28c-.71.26.14-.66-1.94,0a6.41,6.41,0,0,0-1.88-4.63,6.54,6.54,0,0,0-.7-.6l3.2-1.05L23.44,17,18,13s-8,9-9-7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7754e",
    d: "M15 17H33V35H15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#feba57",
    d: "M22.22,27.78h0a3,3,0,0,1-4.15-.56L10,18c-.52-.57-1-3.29-1-3.92V6l10,7v5l3.38,5c1.42,1.84,1.2,3.6-.16,4.74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdccd1",
    d: "M19.12,26.7a1.81,1.81,0,0,0,2.54-2.58c-.71-.7-3.25,1.88-2.54,2.58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e55143",
    d: "M15 34H33V36H15z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d58244",
    d: "M23.44 17L19 13.74 19 17 23.44 17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Complaints50);
export default __webpack_public_path__ + "static/media/icons8-complaints-50.a2aca7c892c8e3cbcebe49f6f2ac3eae.svg";
export { ForwardRef as ReactComponent };